import React from "react";
import Nicholas from "assets/Nicholas.png";

// form & validsation
import * as yup from "yup";
import { FormError, FormRadio, FormDropDown, FormLabel } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";
import Slider from "@material-ui/core/Slider";

const balance = [
  "$0 - $20,000",
  "$20,000 - $50,000",
  "$50,000 - $100,000",
  "$100,000 - $300,000",
  "$301,000 - $600,000",
  "$601,000 - $1M",
  "$1M - $3M",
  "$3M+",
];

// schema
const schema = yup.object().shape({
  financial: yup.object().shape({
    mortgage_who_pays: yup.string().required("You must provide a value"),
    user_debt: yup.string().required("You must provide a value"),
    partner_debt: yup.string().required("You must provide a value"),
    joint_debt: yup.string().required("You must provide a value"),
  }),
});
export function Step14({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(schema),
  });

  function valuetext(value, name) {
    setValue(name, value);
    return `${value}°C`;
  }
  const handleData = (values) => {
    const copy_data = Object.assign({}, store.financial);
    const merger_current_values = { ...copy_data, ...values.financial };
    const mergeToStore = { ...store, financial: merger_current_values };
    onSubmit(mergeToStore);
  };

  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`financial.mortgage_who_pays`}
            className={customClasses.questionText}
            error={errors?.financial?.mortgage_who_pays?.message}
          >
            Who mainly pays the mortgage?
          </FormLabel>
          <article>
            <FormDropDown
              placeholder="Who Pays Mortgage"
              id={`financial.mortgage_who_pays`}
              type="text"
              name={`financial.mortgage_who_pays`}
              error={errors?.financial?.mortgage_who_pays?.message}
              data={[
                "We don't have mortgage debt",
                "Mostly me",
                "About equal",
                `Mostly ${
                  store?.user_details?.partner_first_name
                    ? store?.user_details?.partner_first_name
                    : "my ex-partner"
                }`,
                `It's more complicated`,
              ]}
              setValue={setValue}
              register={register}
              value={watch()?.financial?.mortgage_who_pays}
            />
          </article>
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.user_debt"
            className={customClasses.questionText}
            error={errors?.financial?.user_debt?.message}
          >
            Besides any mortgage, what's your sole debt?
          </FormLabel>

          <article>
            <FormDropDown
              placeholder="Select Your Total Debt"
              id={`financial.user_debt`}
              type="text"
              name={`financial.user_debt`}
              error={errors?.financial?.user_debt?.message}
              data={balance}
              setValue={setValue}
              register={register}
              value={watch()?.financial?.user_debt}
            />
          </article>
        </section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.partner_debt"
            className={customClasses.questionText}
            error={errors?.financial?.partner_debt?.message}
          >
            Besides any mortgage, your best guess of{" "}
            {store?.user_details?.partner_first_name
              ? store?.user_details?.partner_first_name
              : "Your Ex-Partner"}
            ’s sole debt?
          </FormLabel>

          <article>
            <FormDropDown
              placeholder="Select Partner Total Debt"
              id={`financial.partner_debt`}
              type="text"
              name={`financial.partner_debt`}
              error={errors?.financial?.partner_debt?.message}
              data={balance}
              setValue={setValue}
              register={register}
              value={watch()?.financial?.partner_debt}
            />
          </article>
        </section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.joint_debt"
            className={customClasses.questionText}
            error={errors?.financial?.joint_debt?.message}
          >
            Besides any mortgage, what's the total joint debts you both have
            together?
          </FormLabel>

          <article>
            <FormDropDown
              placeholder="Select Joint Total Debt"
              id={`financial.joint_debt`}
              type="text"
              name={`financial.joint_debt`}
              error={errors?.financial?.joint_debt?.message}
              data={balance}
              setValue={setValue}
              register={register}
              value={watch()?.financial?.joint_debt}
            />
          </article>
        </section>
      </section>
    </form>
  );
}
